import { cibReact, cibSymfony, cilCode } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import React from "react";
import { FaPalette, FaReact, FaCode } from "react-icons/fa";
import { RiTailwindCssFill } from "react-icons/ri";

const BOOTSTRAP_FOR_SKILL_ICON = "text-4xl mx-auto inline-block";
const data = {
  document_title: "Welcome to my portfolio !",
  name: "Florent C",
  title: "Full-stack Developer",
  social: {
    github: "https://github.com/florentcussatlegras",
    email: "florent.cussatlegras@gmail.com",
  },
  about: {
    title: "My Background",
    description: [
      "With over 20 years of experience in software development, I began my career in web development, where I worked for five years on a wide range of projects before moving into the industrial sector.",

      "For 15 years, I contributed to the development and evolution of a custom-built ERP solution for an industrial company, gaining strong expertise in software architecture and design.",

      "Five years ago, I decided to return to web development and become a full-stack developer, which brings my total experience in this field to 10 years. Since then, I have specialized in Symfony, earning the Expert-level certification, and explored Symfony UX to enhance the user experience.",

      "At the same time, I have strengthened my skills in JavaScript, TypeScript, React, Express.js or encore Next.js, while adopting Tailwind to build modern and responsive interfaces, as well as using Docker containers for development in isolated, consistent, and easily reproducible environments.",

      "This combination of long-term experience and up-to-date skills allows me to approach web projects with a comprehensive vision, combining robust backend systems with dynamic user interfaces.",
    ],
  },
  skills: [
    {
      skillName: "Fullstack",
      skillIcon: (
        <div className="w-16 h-16 mx-auto">
          <CIcon icon={cilCode} className="w-full h-full" />
        </div>
      ),
    },
    {
      skillName: "Symfony",
      skillIcon: (
        <div className="w-16 h-16 mx-auto">
          <CIcon icon={cibSymfony} className="w-full h-full" />
        </div>
      ),
    },
    {
      skillName: "ReactJS",
      skillIcon: (
        <div className="w-16 h-16 mx-auto">
          <CIcon icon={cibReact} className="w-full h-full" />
        </div>
      ),
    },
    {
      skillName: "TailwindCSS",
      skillIcon: <RiTailwindCssFill className="text-5xl inline-block" />,
    },
  ],
  projects: [
    {
      title: "Nutrition",
      description:
        "To help you adopt a healthier and more balanced diet, build with Symfony and TailwindCSS.",
      image: "screen_nutrition.png",
      tags: ["php", "symfony", "tailwindcss", "symfonyux", "docker"],
      link: "https://fc-nutrition.com",
      linkGithub: "https://github.com/florentcussatlegras/assiette-ideale",
    },
    {
      title: "JobTrackr",
      description:
        "JobTrackr lets you centralize your applications, organize your follow-ups and analyze your performance. Built with React and Express.",
      image: "screen_jobtrackr.png",
      tags: ["expressjs", "reactjs", "tailwindcss"],
      link: "https://job-trackr-production.up.railway.app/",
      linkGithub: "https://github.com/florentcussatlegras/job-trackr.git",
    },
    {
      title: "Ten Thousand Hours",
      description:
        "An app designed to help you manage your work sessions and become an expert, build with NextJS, HeroUI and TailwindCSS.",
      image: "screen_ten_thousand_years.png",
      tags: ["typescript", "nextjs", "heroui", "tailwindcss"],
      link: "https://fc-ten-thousand-hours.com",
      linkGithub: "https://github.com/florentcussatlegras/ten-thousand-hours",
    },
    {
      title: "Site Pulse",
      description:
        "A web auditing tool that automatically evaluates the Performance, Accessibility, SEO, and Best Practices of a given URL. Developed with Symfony, ReactJS, TypeScript, TailwindCSS, and Symfony UX.",
      image: "screen_site_pulse.png",
      tags: [
        "php",
        "symfony",
        "reactjs",
        "typescript",
        "tailwindcss",
        "symfonyux",
        "docker",
      ],
      link: "https://sitepulse-production.up.railway.app/",
      linkGithub: "https://github.com/florentcussatlegras/site-pulse",
    },
    {
      title: "My Bags Shop",
      description:
        "An online shoe shop, build with Symfony, NextJS and MaterialUI.",
      image: "screen_bag_shop.png",
      tags: [
        "php",
        "symfony",
        "reactjs",
        "materialui",
        "javascript",
        "tailwindcss",
      ],
      link: "https://fc-bags-shop.com",
      linkGithub: "https://github.com/florentcussatlegras/my-bags-shop",
    },
    {
      title: "Airbnb Clone",
      description:
        "A booking website imitating Airbnb, build with NextJS and TailwindCSS.",
      image: "screen_airbnb_clone.png",
      tags: ["typescript", "nextjs", "tailwindcss"],
      link: "https://airbnb-clone-git-main-florent-cussatlegras-projects.vercel.app",
      linkGithub: "https://github.com/florentcussatlegras/airbnb-clone",
    },
    {
      title: "Q/A Tech",
      description:
        "A question-and-answer site on modern web development technologies.",
      image: "screen_qa_tech.png",
      tags: ["symfony", "reactjs", "tailwindcss"],
      link: "https://qa-tech.up.railway.app/",
      linkGithub: "https://github.com/florentcussatlegras/skill-drills",
    },
  ],
};
export default data;
